import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar";
import CreateOrUpdateSellerProfileForm
	from "~/modules/admin/components/AdminView/components/AdminSellerProfileSection/components/CreateOrUpdateSellerProfileSidebar/CreateOrUpdateSellerProfileForm.tsx";
import { sellerProfileQueries } from "~/modules/billing/sellerProfile/sellerProfileQueries.ts";
import type { SellerProfile } from "~/modules/billing/sellerProfile/sellerProfileTypes.ts";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	sellerProfile?: SellerProfile
};

const CreateOrUpdateSellerProfileSidebar = ({
	isOpen,
	onClose,
	sellerProfile,
}: Props) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: sellerProfileQueries.details().queryKey });
		onClose();
	}, [onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			<CreateOrUpdateSellerProfileForm onCancel={onClose}
											 onSuccess={handleSuccess}
											 sellerProfileData={sellerProfile} />
		</Sidebar>
	);
};

export default CreateOrUpdateSellerProfileSidebar;
